<template lang="pug">
.row
  .col-12.mb-3
    ul#my-tab.nav.nav-tabs(role='tablist')
      li.nav-item(role='presentation')
        button#detail-tab.nav-link.active(
          @click='activeTab = "detail"'
          aria-controls='detail'
          aria-selected='true'
          data-bs-target='#detail'
          data-bs-toggle='tab'
          role='tab'
          type='button'
        ) {{ $t('modal.envelope.overview') }}
      li.nav-item(role='presentation' v-if='showDocsInfos')
        button#docs-infos-tab.nav-link(
          @click='activeTab = "docs-infos"'
          aria-controls='docs-infos'
          aria-selected='true'
          data-bs-target='#docs-infos'
          data-bs-toggle='tab'
          role='tab'
          type='button'
        ) {{ $t('modal.envelope.documentsInfo') }}
      li.nav-item(role='presentation' v-if='showLogs')
        button#history-tab.nav-link(
          @click='activeTab = "history"'
          aria-controls='history'
          aria-selected='true'
          data-bs-target='#history'
          data-bs-toggle='tab'
          role='tab'
          type='button'
        ) {{ $t('modal.envelope.history') }}
    #myTabContent.tab-content.pt-3
      #detail.tab-pane.fade.show.active(
        aria-labelledby='settings-tab'
        role='tabpanel'
      )
        .documents-header(v-if='documents.length > 1')
          .overview-section-title
            span.text {{ $t('modal.envelope.documents', { total: documents.length }) }}
            icon.fs-6(
              name='circle-question'
              v-tooltip:top='$t("modal.envelope.documentsInfoHint", { total: documents.length })'
            )
          document-badge-selector.documents-header-badges(
            :documents='documents'
            :selected-document='currentDocument'
            @select='currentDocument = $event'
          )
        .row.overview-row
          .col-12.col-xl-6.overview-cards
            envelope-info-card(
              :days-for-notification='daysForNotification'
              :envelope='envelope'
              :signatures-summary='mySignaturesSummary'
            )
            info-card.overview-actions-card(
              :title='$t("modal.envelope.envelopeActions")'
              icon='arrow-down-to-bracket'
              icon-color='blue'
            )
              envelope-actions-bar(
                :documents='documents'
                :download-label='downloadLabel'
                :envelope='envelope'
                :envelope-is-completed='envelopeIsCompleted'
                :envelope-is-pending='envelopeIsPending'
                :only-face-to-face='onlyFaceToFace'
                :resend-tooltip-message='resendTooltipMessage'
                :user-view='userView'
                @cancel-envelope='cancelEnvelope'
                @download-completed-envelope='downloadEnvelopeDocumentsAndSignaturePage(envelope)'
                @download-envelope='downloadEnvelope(envelope)'
                @download-signature-page='downloadSignaturePage(envelope)'
                @resend-notification='reNotify'
                inline
              )
            recipients-panel(
              :envelope-state='envelope.state'
              :only-face-to-face='onlyFaceToFace'
              :recipients='recipients'
              :resend-tooltip-message='resendTooltipMessage'
              :selected-doc-info='selectedDocInfo'
              :user-view='userView'
              @edit-recipient='editRecipient'
              @resend-notification='reNotify'
            )
            info-card(
              :title='$t("modal.envelope.review.visibility")'
              icon='eye'
              icon-color='green'
              v-if='envelope && "visibility" in envelope'
            )
              template(v-slot:action)
                button.icon-button(
                  @click='openEditVisibilityModal'
                  type='button'
                  v-if='availableVisibilities.length && (isSender || isOwner)'
                )
                  icon(name='pen-to-square')
              span(style='margin-right: 0.3rem') {{ visibilityLabel }}
              icon.fs-6(
                name='circle-question'
                v-if='!envelope.visibility'
                v-tooltip:top='$t("modal.envelope.visibilityUnsetHint")'
              )
            info-card(
              :title='$t("modal.envelope.message")'
              icon='envelope'
              icon-color='blue'
            )
              p.mb-0 {{ this.message ? this.message : $t('modal.envelope.noMessageSent') }}
            info-card(
              :title='$t("modal.envelope.notes")'
              icon='note-sticky'
              icon-color='green'
              v-if='userView === "sender"'
            )
              p.mb-0(v-if='notes.data.length === 0') {{ $t('modal.envelope.noNotesAdded') }}
              .notes-item(
                :key='note.id'
                v-else
                v-for='note in notes.data'
              )
                .recipient-name {{ note.recipient.name }}
                div
                  span {{ note.recipient.value }}
                div
                  IconStatus(:iconStatus='note.recipient.state')
                  span.text {{ $t(note.recipient.state) }}
                .mt-2
                  .text {{ note.message }}
                    span.fw-light {{ note.created_at | date }}
                      |
                      | às {{ note.created_at | time }}
          .col-12.col-xl-6.mt-4.overview-viewer
            template(v-if='documents')
              documents-viewer(
                :document='currentDocument'
                :documents='documents'
                :envelope='envelope'
                :renderScale='0.95'
                @document-selected='currentDocument = $event'
                hide-selector
              )
      #docs-infos.tab-pane.fade(
        aria-labelledby='settings-tab'
        role='tabpanel'
        v-if='showDocsInfos'
      )
        .doc-info-row(
          :key='item.doc.id'
          v-for='item in documentsRecipientsInfo'
        )
          .doc-info-preview
            img(
              :src='item.doc.links.preview'
              v-if='item.doc.links && item.doc.links.preview'
            )
            icon(name='file' v-else)
          .doc-info-columns
            .doc-info-column
              document-participation-card(
                :document='item.doc'
                :is-signer='recipientSignsDocument(myFullRecipient, item.doc)'
                :recipient='myRecipient'
                :role='myRecipientRoleForDocument(item.doc)'
              )
            .doc-info-column
              info-card(
                :title='$t("modal.envelope.signers")'
                icon='signature'
                icon-color='green'
              )
                .doc-info-signer(
                  :key='entry.recipient.id'
                  v-for='entry in item.signers.filter((s) => s.signsThisDoc)'
                )
                  icon(name='signature')
                  span.doc-info-signer-name {{ entry.recipient.addressees[0].name }}
                  span.doc-info-signer-contact(
                    v-if='entry.recipient.addressees[0].via !== "face-to-face"'
                  )
                    | : {{ entry.recipient.addressees[0].value }}
      #history.tab-pane.fade.show(
        aria-labelledby='settings-tab'
        role='tabpanel'
        v-if='showLogs'
      )
        .row
          .col-12
            .card-body.shadow(:key='index' v-for='(log, index) in logs.data')
              icon.icon--finished(name='circle')
              span.text {{ log.created_at | date }} às {{ log.created_at | time }}
                |
                | {{ log.message }}
          simple-paginator(:payload='logs' @navigate='fetchEnvelopeLogs')
  .col-12(v-if='activeTab !== "detail"')
    envelope-actions-bar(
      :documents='documents'
      :download-label='downloadLabel'
      :envelope='envelope'
      :envelope-is-completed='envelopeIsCompleted'
      :envelope-is-pending='envelopeIsPending'
      :only-face-to-face='onlyFaceToFace'
      :resend-tooltip-message='resendTooltipMessage'
      :show-resend-cancel='false'
      :user-view='userView'
      @cancel-envelope='cancelEnvelope'
      @download-completed-envelope='downloadEnvelopeDocumentsAndSignaturePage(envelope)'
      @download-envelope='downloadEnvelope(envelope)'
      @download-signature-page='downloadSignaturePage(envelope)'
      @resend-notification='reNotify'
    )
  reject-envelope-modal(
    :token='this.$route.params.token'
    @refresh='fetchEnvelope'
  )
  edit-recipient-modal(
    :recipient='recipients[selectedRecipientIndex]'
    @deselect='deselectRecipient'
    @edit='sendNewRecipient'
    ref='editRecipientModal'
    v-if='selectedRecipientIndex || selectedRecipientIndex === 0'
  )
  error-modal(:message='this.errorMessage')
  cancel-envelope-modal(
    :envelopeId='this.$route.params.id'
    @refresh='cancelFeedback'
    ref='cancelEnvelopeModal'
  )
  canceled-envelope-feedback-modal(ref='canceledEnvelopeFeedbackModal')
  edit-visibility-modal(
    :visibilityOptions='visibilityOptionsForModal'
    :visibilitySelected='currentVisibilityValue'
    @change='handleVisibilityChange'
    ref='editVisibilityModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import RejectEnvelopeModal from '@/modules/business/components/organisms/modals/RejectEnvelopeModal.vue';
import CancelEnvelopeModal from '@/modules/business/components/organisms/modals/CancelEnvelopeModal.vue';
import ErrorModal from '@/modules/business/components/organisms/modals/ErrorModal.vue';
import EditRecipientModal from '@/modules/business/components/organisms/modals/EditRecipientModal.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import RecipientsService from '@/modules/business/services/http/envelopes/RecipientsService';
import TeamsService from '@/modules/account/services/http/TeamsService';
import DocumentsViewer from '@/ui/organisms/DocumentsPDFViewer.vue';
import alert from '@/modules/account/common/alert';
import RecipientType from '@/enums/RecipientType';
import EnvelopeState from '@/enums/EnvelopeState';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
import StorageHttp from '@/services/StorageHttp';
// eslint-disable-next-line max-len
import CanceledEnvelopeFeedbackModal from '@/modules/business/components/organisms/modals/CanceledEnvelopeFeedbackModal.vue';
import EnvelopeDownloadsFactory from '@/modules/business/common/EnvelopeDownloads/EnvelopeDownloadsFactory';
import EditVisibilityModal from '@/modules/business/components/organisms/modals/EditVisibilityModal.vue';
import {
  getAllowedVisibilities,
  getCurrentVisibilityValue,
  getVisibilityOptions,
} from '@/modules/business/common/envelopeVisibility';
import EnvelopeInfoCard from '@/modules/business/components/molecules/EnvelopeInfoCard.vue';
import DocumentBadgeSelector from '@/modules/business/components/molecules/DocumentBadgeSelector.vue';
import DocumentParticipationCard from '@/modules/business/components/molecules/DocumentParticipationCard.vue';
import RecipientsPanel from '@/modules/business/components/molecules/RecipientsPanel.vue';
import EnvelopeActionsBar from '@/modules/business/components/organisms/EnvelopeActionsBar.vue';
import InfoCard from '@/modules/business/components/molecules/InfoCard.vue';

export default {
  name: 'DocumentsInfoPage',
  components: {
    Icon,
    IconStatus,
    RejectEnvelopeModal,
    CancelEnvelopeModal,
    ErrorModal,
    Document,
    DocumentsViewer,
    SimplePaginator,
    EditRecipientModal,
    CanceledEnvelopeFeedbackModal,
    EditVisibilityModal,
    EnvelopeInfoCard,
    DocumentBadgeSelector,
    DocumentParticipationCard,
    RecipientsPanel,
    EnvelopeActionsBar,
    InfoCard,
  },
  data() {
    return {
      envelope: '',
      logs: {
        data: [],
        links: {},
        meta: {},
      },
      notes: {
        data: [],
        links: {},
        meta: {},
      },
      currentDocument: {},
      documents: [],
      recipients: [],
      recipientAction: null,
      selectedRecipientIndex: null,
      message: '',
      errorMessage: '',
      teamName: '',
      teams: [],
      signerTypes: ['signer', 'approver', 'in-person-signer'],
      activeTab: 'detail',
    };
  },
  async created() {
    this.$store.dispatch('page/setTitle', 'Envelopes');
    this.$store.dispatch('page/setClass', 'business documents');
    try {
      this.$loading(true);
      await this.fetchEnvelope();
      if (!this.$route.params.token) {
        await this.fetchEnvelopeLogs();
        await this.fetchEnvelopeNotes();
        this.$store.dispatch('page/setHead', {
          title: this.$t('sentEnvelope'),
          action: { name: 'business.documents.sent' },
        });
      } else {
        this.$store.dispatch('page/setHead', {
          title: this.$t('receivedEnvelope'),
          action: { name: 'business.documents.inbox' },
        });
      }
      this.$loading(false);
    } catch {
      this.$loading(false);
    }
  },
  computed: {
    isOwner() {
      return this.$store.state.organizations.selected?.is_owner;
    },
    isSender() {
      return this.$root.user?.email === this.envelope.sender?.email;
    },
    showLogs() {
      if (this.$route.params.token) {
        return false;
      }
      return true;
    },
    isDocWithoutSignatures() {
      if (!this.selectedDocInfo) {
        return false;
      }
      return this.envelopeIsCompleted && !this.selectedDocInfo.hasSigned;
    },
    showDocsInfos() {
      return this.documents.length > 0;
    },
    documentsInfo() {
      const signers = this.recipients.filter((r) =>
        this.signerTypes.includes(r.type)
      );
      return this.documents.map((doc) => ({
        doc,
        hasSignature: doc.stage !== 'original' && this.envelopeIsCompleted,
        signers: signers.map((r) => ({
          recipient: r,
          signsThisDoc: !(r.exclude_documents ?? []).includes(doc.id),
        })),
      }));
    },
    documentsRecipientsInfo() {
      const signers = this.recipients.filter((r) =>
        this.signerTypes.includes(r.type)
      );
      return this.documents.map((doc) => ({
        doc,
        signers: signers.map((recipient) => ({
          recipient,
          signsThisDoc: this.recipientSignsDocument(recipient, doc),
        })),
      }));
    },
    selectedDocInfo() {
      if (!this.currentDocument?.id) {
        return null;
      }
      const doc = this.currentDocument;
      const hasSigned = doc.stage !== 'original';
      const signers = this.recipients.filter(
        (r) =>
          this.signerTypes.includes(r.type) &&
          !(r.exclude_documents ?? []).includes(doc.id)
      );
      return { doc, hasSigned, signers };
    },
    isAllowToDownloadSignaturePage() {
      return this.envelope.state === EnvelopeState.COMPLETED;
    },
    getToken() {
      return this.$route.params.token;
    },
    daysForNotification() {
      return this.convertDateToDaysForReminderAt(
        this.envelope.effective_date_reminder_at
      );
    },
    userView() {
      if (this.$route.params.token) {
        return 'recipient';
      }
      return 'sender';
    },
    envelopeIsPending() {
      return this.envelope.state === EnvelopeState.IN_TRANSIT;
    },
    envelopeIsCompleted() {
      return this.envelope.state === EnvelopeState.COMPLETED;
    },
    resendTooltipMessage() {
      if (this.envelope.recipients[0].routing_order > 0) {
        return this.$t('sentEnvelopesCardTable.tooltipResendMessage');
      }
      return this.$t('sentEnvelopesCardTable.tooltipResendMessageForAll');
    },
    onlyFaceToFace() {
      const res = this.recipients.filter(
        (r) => r.addressees[0].via !== 'face-to-face'
      );
      return res.length ? false : true;
    },
    availableVisibilities() {
      return getAllowedVisibilities(this.$store.state.organizations.selected);
    },
    visibilityLabel() {
      if (!this.envelope.visibility) {
        return this.$t('modal.envelope.visibilityUnset');
      }
      if (this.envelope.visibility === 'team') {
        return `${this.$t(
          'modal.envelope.review.visibilityOptions.teamLabel'
        )} | ${this.teamName}`;
      }
      return this.$t(
        `modal.envelope.review.visibilityOptions.${this.envelope.visibility}`
      );
    },
    visibilityOptionsForModal() {
      return getVisibilityOptions({
        visibilities: this.availableVisibilities,
        teams: this.teams,
        translate: (key) => this.$t(key),
      });
    },
    currentVisibilityValue() {
      return getCurrentVisibilityValue(this.envelope);
    },
    myRecipient() {
      if (this.getToken) {
        return this.recipientAction;
      }
      return (
        this.recipients.find(
          (r) => r.addressees?.[0]?.value === this.$root.user?.email
        ) || null
      );
    },
    myFullRecipient() {
      if (!this.myRecipient) {
        return null;
      }
      return this.recipients.find((r) => r.id === this.myRecipient.id) || null;
    },
    downloadLabel() {
      return this.downloadTitleRestriction(this.envelope.state);
    },
    mySignaturesSummary() {
      const isSignerType =
        this.myRecipient?.type === RecipientType.SIGNER ||
        this.myRecipient?.type === RecipientType.IN_PERSON_SIGNER;
      if (!this.myRecipient || !this.documents.length || !isSignerType) {
        return null;
      }
      const total = this.documents.length;
      const count = this.documentsInfo.filter((item) =>
        item.signers.some(
          (s) => s.recipient.id === this.myRecipient.id && s.signsThisDoc
        )
      ).length;
      return { count, total };
    },
  },
  methods: {
    recipientSignsDocument(recipient, doc) {
      if (!recipient) {
        return false;
      }
      return !(recipient.exclude_documents ?? []).includes(doc.id);
    },
    myRecipientRoleForDocument(doc) {
      if (!this.myRecipient) {
        return '';
      }
      if (!this.recipientSignsDocument(this.myFullRecipient, doc)) {
        return this.$t('modal.envelope.viewer');
      }
      return this.recipientLabel(this.myRecipient.type);
    },
    recipientLabel(recipientType) {
      const typeValue = RecipientType.values.filter(
        (type) => type.value === recipientType
      );
      if (!typeValue.length) {
        return '';
      }
      return typeValue[0].value !== 'carbon-copy'
        ? this.$t(`modal.envelope.${typeValue[0].value}`)
        : this.$t('modal.envelope.viewer');
    },
    async fetchEnvelope() {
      StorageHttp.supressDefault = true;
      let envelope;
      if (this.getToken) {
        await RecipientsService.listEspecificRecipientEnvelope(
          this.$route.params.token
        ).then((result) => {
          envelope = result.data.envelope;
          envelope.recipientState = result.data.state;
          this.recipientAction = {
            id: result.data.id,
            type: result.data.type,
            state: result.data.state,
          };
        });
      } else {
        await EnvelopesService.listEspecificEnvelope(this.$route.params.id, {
          extended: true,
        })
          .then((result) => {
            envelope = result.data;
          })
          .catch(() => {
            alert
              .fireAlert(this.$t('feedback.envelopeNotFound'), {
                classes: 'alert-danger',
                styles:
                  'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
                icon: 'triangle-exclamation',
              })
              .finally(() => {
                StorageHttp.supressDefault = false;
              });
          });
      }
      this.envelope = envelope;
      this.recipients = envelope.recipients.sort(
        (a, b) => a.routing_order - b.routing_order
      );
      this.message = envelope.message;

      this.documents = envelope.documents.map((doc) => {
        const document = doc;
        document.src = document.links.display;
        return document;
      });
      this.currentDocument = this.documents[0];
      if (envelope.visibility === 'team' && envelope.team) {
        try {
          const res = await TeamsService.listSpecificTeam(envelope.team);
          this.teamName = res.data.name;
        } catch {
          this.teamName = '';
        }
      }
      if (this.availableVisibilities.includes('team')) {
        try {
          const res = await TeamsService.list();
          this.teams = res.data.data;
        } catch {
          this.teams = [];
        }
      }
    },
    openEditVisibilityModal() {
      this.$refs.editVisibilityModal.open();
    },
    async handleVisibilityChange(payload) {
      this.$loading(true);
      try {
        await EnvelopesService.changeVisibility(this.envelope.id, payload);
        this.$refs.editVisibilityModal.close();
        await this.fetchEnvelope();
      } catch (error) {
        alert.fireAlert(
          `${this.$t('modal.envelope.sentEnvelopeError')} ${
            error.response.data.message
          }`,
          {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          }
        );
      } finally {
        this.$loading(false);
      }
    },
    async reNotify() {
      await EnvelopesService.reNotify(this.envelope.id).then(() => {
        alert.fireAlert(this.$t('feedback.notificationResent'), {
          classes: 'alert-success',
          styles:
            'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
          icon: 'circle-check',
        });
      });
    },
    fetchEnvelopeLogs(page = 1) {
      EnvelopesService.listEvents(this.envelope.id, {
        page,
      }).then((result) => {
        this.logs = result.data;
      });
    },
    fetchEnvelopeNotes() {
      EnvelopesService.listEnvelopeNotes(this.envelope.id).then((res) => {
        this.notes = res.data;
      });
    },
    async downloadEnvelope(envelope) {
      this.$loading(true);
      try {
        const envelopeDownloads =
          EnvelopeDownloadsFactory.createEnvelopeDownloads(
            this.getToken ? this.getToken : envelope.id,
            this.getToken ? 'public' : 'private'
          );

        await envelopeDownloads.downloadDocuments(envelope.title);
      } finally {
        this.$loading(false);
      }
    },
    async downloadSignaturePage(envelope) {
      this.$loading(true);
      try {
        const envelopeDownloads =
          EnvelopeDownloadsFactory.createEnvelopeDownloads(
            this.getToken ? this.getToken : envelope.id,
            this.getToken ? 'public' : 'private'
          );

        await envelopeDownloads.downloadSignaturePage(envelope.title);
      } finally {
        this.$loading(false);
      }
    },
    async downloadEnvelopeDocumentsAndSignaturePage(envelope) {
      this.$loading(true);
      try {
        const envelopeDownloads =
          EnvelopeDownloadsFactory.createEnvelopeDownloads(
            this.getToken ? this.getToken : envelope.id,
            this.getToken ? 'public' : 'private'
          );
        await envelopeDownloads.downloadEnvelopeDocumentsAndBackgroundSheet(
          envelope.title
        );
      } finally {
        this.$loading(false);
      }
    },
    getHowManyDaysBetweenDates(dateOne, dateTwo) {
      const convertedDate = dateOne ? new Date(dateOne) : new Date();
      const oneDay = 24 * 60 * 60 * 1000;
      const firstDate = convertedDate;
      const secondDate = new Date(dateTwo);

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      return diffDays;
    },
    convertDateToDaysForReminderAt(dateReminderAt) {
      const daysBetween = this.getHowManyDaysBetweenDates(
        dateReminderAt,
        this.envelope.effective_until
          ? new Date(this.envelope.effective_until).fp_incr(1)
          : ''
      );
      const days = dateReminderAt ? daysBetween : null;
      if (days >= 1 && days < 15) {
        return 1;
      }
      if (days >= 15 && days < 30) {
        return 15;
      }
      if (days >= 30) {
        return 30;
      }
      return null;
    },
    downloadTitleRestriction(envelopeState) {
      if (envelopeState === EnvelopeState.COMPLETED) {
        return this.$t('signedDocuments');
      }
      return this.$t('originalDocuments');
    },
    editRecipient(index) {
      this.selectedRecipientIndex = index;

      this.$nextTick(() => {
        this.$refs.editRecipientModal.$refs.modal.open();
      });
    },
    deselectRecipient() {
      this.selectedRecipientIndex = null;
    },
    async sendNewRecipient(newRecipientdata) {
      const via = newRecipientdata.via;
      // Building Request payload
      const payload = {
        name: newRecipientdata.name,
        addressees: [
          {
            identifiers:
              this.recipients[this.selectedRecipientIndex].addressees[0]
                .identifiers,
            via: via,
            value:
              via === 'email' ? newRecipientdata.email : newRecipientdata.phone,
            name: newRecipientdata.name,
          },
        ],
      };

      this.$loading(true);
      try {
        await RecipientsService.editRecipient(
          this.recipients[this.selectedRecipientIndex].id,
          this.envelope.id,
          payload
        );
        await this.fetchEnvelope();
      } catch (err) {
        console.log(err);
      } finally {
        this.$refs.editRecipientModal.$refs.modal.close();
        this.deselectRecipient();
        this.$loading(false);
      }
    },
    cancelEnvelope() {
      this.$refs.cancelEnvelopeModal.$refs.modal.open();
    },
    cancelFeedback() {
      this.fetchEnvelope();
      this.$refs.canceledEnvelopeFeedbackModal.$refs.modal.open();
    },
  },
};
</script>

<style scoped lang="stylus">
.doc-info-row
  display: flex
  gap: 1.25rem
  padding: 1.25rem 0
  border-top: 1px solid rgba(204, 204, 204, .5)

  &:first-child
    border-top: none
    padding-top: 0

.doc-info-preview
  flex: 0 0 auto
  width: 140px
  height: 180px
  display: flex
  align-items: center
  justify-content: center
  background-color: #F7F7F7
  border: 1px solid rgba(204, 204, 204, .5)
  border-radius: 8px
  overflow: hidden
  font-size: 2rem
  color: #CCCCCC

  img
    width: 100%
    height: 100%
    object-fit: cover
    object-position: top

.doc-info-columns
  display: flex
  flex-wrap: wrap
  gap: 1.25rem
  flex: 1 1 auto
  min-width: 0

.doc-info-column
  flex: 1 1 320px
  min-width: 0

.doc-info-signer
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 0.4rem
  padding: 0.5rem 0
  font-size: 0.85rem
  border-top: 1px solid rgba(204, 204, 204, .5)

  &:first-child
    border-top: none
    padding-top: 0

.doc-info-signer-name
  font-weight: 600

.doc-info-signer-contact
  color: #495057

@media only screen and (max-width: 768px)
  .doc-info-row
    flex-direction: column

  .doc-info-preview
    width: 100%
    height: 160px

  .doc-info-columns
    flex-direction: column
    flex-wrap: nowrap

  .doc-info-columns
    .pill
      white-space: normal
      text-align: left

.overview-row
  display: flex
  flex-wrap: wrap
.overview-cards
  order: 2
  display: flex
  flex-direction: column
.overview-viewer
  order: 1
@media(min-width: 992px)
  .overview-cards
    order: 2
  .overview-viewer
    order: 1
@media only screen and (max-width: 768px)
  .overview-actions-card
    order: -1
.documents-header
  margin-bottom: 1.5rem

  .documents-header-badges
    margin-bottom: 0
.overview-section-title
  display: flex
  align-items: center
  gap: 0.5rem
  margin-bottom: 0.75rem
  font-weight: 600
  font-size: 0.9rem
.icon-button
  display: flex
  align-items: center
  justify-content: center
  width: 1.75rem
  height: 1.75rem
  border: none
  background: transparent
  color: #007bff
.notes-item
  padding: 0.75rem 0
  border-top: 1px solid rgba(204, 204, 204, .5)
  &:first-child
    border-top: none
    padding-top: 0
.recipient-name
  font-style: normal
  font-weight: 600
  font-size: 14px
</style>
